class ReauthService {
  /* @ngInject */
  constructor($uibModal, $window, urls) {
    this.$uibModal = $uibModal;
    this.LOGIN = urls.LOGIN;
    this.location = $window.location;
  }

  open() {
    this
      .$uibModal
      .open({
        animation: true,
        template: '<reauth></reauth>',
        backdrop: 'static',
      });
  }

  reauth() {
    const { pathname, search } = this.location;
    this.LOGIN += `&state=${pathname}${search}`;

    if (!this.LOGIN.includes('code=')) this.location.href = this.LOGIN;
  }
}

export default ReauthService;



// WEBPACK FOOTER //
// ./client/components/auth/reauth/reauth.service.js